<template>
  <div id="app">
    <!-- Navigation Components (only show when authenticated and not on auth pages) -->
    <!-- <NavigationDrawer v-if="shouldShowNavigation" /> -->
    <BackButton v-if="shouldShowBackButton" />

    <router-view />

    <!-- Bottom Navigation (persistent across all authenticated pages) -->
    <BottomNavigation v-if="shouldShowNavigation" />

    <!-- In-app notification toast for foreground FCM messages -->
    <NotificationToast />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// import NavigationDrawer from './components/NavigationDrawer.vue'
import BackButton from './components/BackButton.vue'
import BottomNavigation from './components/BottomNavigation.vue'
import NotificationToast from './components/NotificationToast.vue'

export default {
  name: 'App',
  components: {
    // NavigationDrawer,
    BackButton,
    BottomNavigation,
    NotificationToast
  },
  computed: {
    ...mapState(['authState']),
    ...mapGetters(['isAuthenticated']),
    shouldShowNavigation() {
      // Show navigation if authenticated and not on auth pages
      const isAuthPage = this.$route.path.startsWith('/auth')
      return this.isAuthenticated && !isAuthPage
    },
    shouldShowBackButton() {
      // Show back button on all authenticated pages except home, auth pages, and bottom nav routes
      // We also hide it on CollateralDetail because that view has its own integrated header
      const isAuthPage = this.$route.path.startsWith('/auth')
      const isCollateralView = this.$route.name === 'CollateralDetail'
      const bottomNavRoutes = ['/welcome', '/crm', '/collateral', '/followups']
      const isBottomNavRoute = bottomNavRoutes.includes(this.$route.path)
      
      return this.isAuthenticated && !isAuthPage && !isBottomNavRoute && !isCollateralView
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.navbar {
  background-color: #2c3e50;
  color: white;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-brand {
  font-size: 1.5rem;
  font-weight: bold;
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.nav-links a {
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.nav-links a:hover,
.nav-links a.router-link-active {
  background-color: #34495e;
}

.logout-btn {
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.logout-btn:hover {
  background-color: #c0392b;
}
</style>
